import { render, staticRenderFns } from "./addCommunication.vue?vue&type=template&id=5c364e04&scoped=true&"
import script from "./addCommunication.vue?vue&type=script&lang=js&"
export * from "./addCommunication.vue?vue&type=script&lang=js&"
import style0 from "./addCommunication.vue?vue&type=style&index=0&id=5c364e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c364e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c364e04')) {
      api.createRecord('5c364e04', component.options)
    } else {
      api.reload('5c364e04', component.options)
    }
    module.hot.accept("./addCommunication.vue?vue&type=template&id=5c364e04&scoped=true&", function () {
      api.rerender('5c364e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/components/addCommunication.vue"
export default component.exports